import { lazyStories } from './storybook'
import Components from './components/components.stories'

const Palette = lazyStories(() => import('./palette/palette.stories'))
const Gradient = lazyStories(() => import('./palette/gradient.stories'))
const Typography = lazyStories(() => import('./palette/typography.stories'))
const Shapes = lazyStories(() => import('./components/shapes.stories'))
const Creatures = lazyStories(() => import('./creatures.stories'))
const Patterns = lazyStories(() => import('./patterns.stories'))
const LivingSun = lazyStories(() => import('./living-sun.stories'))
const RealisticTree = lazyStories(() => import('./realistic-tree.stories'))
const JsonViewer = lazyStories(() => import('../src/dev/json-viewer.stories'))
const PropsEditor = lazyStories(
  () => import('./storybook/props-editor.stories'),
)

const ErrorFallback = lazyStories(() => import('./system/error-boundary.stories'))

export default {
  ErrorFallback: { UnknownError: ErrorFallback.UnknownError },
  DesignSystem: {
    Palette: Palette.Default,
    Gradient: {
      Default: Gradient.Default,
      AnimatedGradients: Gradient.Animated,
    },
    Typography: {
      Sizes: Typography.Sizes,
      Transformations: Typography.Transformations,
      GlowingText: Typography.GlowingText,
    },
    Shapes: {
      AllShapes: Shapes.AllShapes,
      ClipPathReveal: Shapes.ClipPathRevealStory,
      ImageShapes: Shapes.ImageShapesStory,
      LoaderSet: Shapes.LoaderSetStory,
      MorphingLoader: Shapes.MorphingLoaderStory,
      PatternFill: Shapes.PatternFillStory,
      ShapeMorphGallery: Shapes.ShapeMorphGalleryStory,
      Fake3DShapes: Shapes.Fake3DShapesStory,
    },
    Creatures: Creatures.EmojiCreature,
    Patterns: Patterns.Patterns,
    LivingSun: LivingSun.LivingSun,
    RealisticTree: RealisticTree.RealisticTree,
  },
  Components,
  JsonViewer: JsonViewer.Default,
  Storybook: {
    PropsEditor: PropsEditor.AllTypes,
  },
}
